module.exports = __webpack_public_path__ + "static/media/Banner_Antonio_Adolfo.520ab403.png";